import axios, {AxiosInstance, AxiosResponse} from "axios";
import { GetLocalStorage } from "./index";
import {AxiosError} from "axios/index";
import {RouteNames} from "../constants";


export default function api(url: string, contentType?: string) {
  const token = GetLocalStorage("token");

  const instance = axios.create({
    baseURL: url,
    headers: {
      "Content-Type": contentType || "application/json",
      Authorization: `Bearer ${token}`,
    },
  })


  function createAxiosResponseInterceptor(axiosInstance: AxiosInstance) {
    axiosInstance.interceptors.response.use((response: AxiosResponse): AxiosResponse => {
      return response;
    }, (error: AxiosError): Promise<AxiosError> => {
      if (error.response?.status === 401 && localStorage.getItem('token')) {
        const err = error as AxiosError<{ message: string }>;
        window.location.replace(`${RouteNames.LOGIN}?session-expired`);
      }
      return Promise.reject(error);
    });
  }

  createAxiosResponseInterceptor(instance)
  return instance;
}